"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sequence = exports.sequenceWhile = void 0;

var _is = require("../is/is");

var alwaysTrue = function alwaysTrue() {
  return true;
};

var sequenceWhile = function sequenceWhile(predicateFn, source) {
  if (typeof predicateFn !== "function") {
    throw new TypeError("Invalid predicate control function. Expected function but got \"".concat(JSON.stringify(predicateFn), "\""));
  }

  if (!Array.isArray(source) || Array.isArray(source) && source.length === 0) {
    throw new TypeError("Invalid source array. Expected array of functions but got \"".concat(JSON.stringify(source), "\""));
  }

  var index = 0;
  var resolved = [];

  var queueNext = function queueNext(promise) {
    return promise.then(function (result) {
      resolved.push(result);

      if (predicateFn(result) === true) {
        var nextPromiseFn = source[++index];

        if ((0, _is.is)(nextPromiseFn)) {
          return queueNext(Promise.resolve(nextPromiseFn(result)));
        } // no more functions to process


        return resolved;
      } // predicate function failed, return what already resolved and stop
      // processing further


      return resolved;
    });
  };

  return queueNext(Promise.resolve(source[0]()));
};

exports.sequenceWhile = sequenceWhile;

var sequence = function sequence(source) {
  return sequenceWhile(alwaysTrue, source);
};

exports.sequence = sequence;